module.exports = __webpack_public_path__ + "img/load.a9163aff.png";